import { Children as ReactChildren, cloneElement, type ReactElement, memo } from 'react';

import { CopyTooltipLayout } from './CopyTooltipLayout.tsx';
import { DEFAULT_FEEDBACK_DISPLAY_DURATION_MS, useCopyTooltipState } from './useCopyTooltipState.ts';

interface CopyTooltipProps {
  onClick: () => void;
  tooltip: string;
  copiedTooltip: string;
  /**
   * The duration of displaying the copied feedback tooltip in milliseconds.
   * @default 3000
   */
  duration?: number;
  disabled?: boolean;
  children: ReactElement;
}

export const CopyTooltip = memo(function CopyTooltip({
  onClick,
  children,
  tooltip,
  copiedTooltip,
  duration = DEFAULT_FEEDBACK_DISPLAY_DURATION_MS,
  disabled,
}: CopyTooltipProps) {
  const { feedbackVisible, onCopyClick, hintVisible, onHintVisibleChange } = useCopyTooltipState({ duration, onCopyClick: onClick });

  return (
    <CopyTooltipLayout
      tooltip={tooltip}
      copiedTooltip={copiedTooltip}
      feedbackVisible={feedbackVisible}
      hintVisible={hintVisible}
      onHintVisibleChange={onHintVisibleChange}
      disabled={disabled}>
      {cloneElement(ReactChildren.only(children), { onClick: onCopyClick })}
    </CopyTooltipLayout>
  );
});

export { CopyTooltipLayout, useCopyTooltipState };
